export const setCookie = (name, value, days) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  // Setting domain to .spin.tf allows sharing across subdomains (and field.localhost for local dev)
  const domain = window.location.hostname.includes("localhost")
    ? window.location.hostname.includes("field.")
      ? "; domain=.localhost" // special handling if they map field.localhost
      : "; domain=localhost"
    : "; domain=.spin.tf";
  document.cookie = name + "=" + (value || "") + expires + domain + "; path=/";
};

export const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const eraseCookie = (name) => {
  const domain = window.location.hostname.includes("localhost")
    ? window.location.hostname.includes("field.")
      ? "; domain=.localhost"
      : "; domain=localhost"
    : "; domain=.spin.tf";
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT" + domain;
};
